module.exports = __webpack_public_path__ + "static/media/profile_active.97c32428.svg";